<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Stock Details'"></Breadcrumbs>
      <StockReport />
    </div>
    <div class="col-md-12 home-tabs-body"></div>
  </v-row>
</template>

<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import StockReport from "@/components/reports/StockReport.vue";

export default {
  name: "StockdetailsReport",
  components: { Breadcrumbs, StockReport },
};
</script>
